import React from "react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";

export default function SliderGallery({ images = [] }) {
  return (
    <Swiper
      navigation
      loop
      modules={[Navigation]}
      className="relative group h-[50vh] md:h-[100vh]"
    >
      {images.map((item) => (
        <SwiperSlide key={item.id ?? item.image}>
          <div className="h-full bg-slate-100">
            <img
              className="h-full w-full object-cover"
              src={process.env.REACT_APP_IMAGE + "/" + item.image}
              alt={item?.alt || "gallery"}
              loading="lazy"
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
